import { render, staticRenderFns } from "./SignificantAssetsYN.vue?vue&type=template&id=848b5784"
import script from "./SignificantAssetsYN.vue?vue&type=script&lang=js"
export * from "./SignificantAssetsYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports